/// <reference types="vite/client" />
type Mod = { default: () => unknown | Promise<unknown> };

const moduleLoaders = import.meta.glob<Mod>("../modules/*.ts");
const componentLoaders = import.meta.glob<Mod>("../components/*.ts");
const baseLoaders = import.meta.glob<Mod>("../base/*.ts");
const layoutLoaders = import.meta.glob<Mod>("../layout/*.ts");

async function runFrom(loaders: Record<string, () => Promise<Mod>>, file: string) {
    const key = Object.keys(loaders).find(k => k.endsWith(`/${file}.ts`));
    if (!key) throw new Error(`Module not found: ${file}`);
    const mod = await loaders[key]();
    return mod.default?.();
}

export async function runModuleDefault(file: string, testEl: string = "default") {
    if (testEl !== "default" && !document.querySelector(testEl)) return;
    return runFrom(moduleLoaders, file);
}

export async function runComponentDefault(file: string, testEl: string = "default") {
    if (testEl !== "default" && !document.querySelector(testEl)) return;
    return runFrom(componentLoaders, file);
}

export async function runDefault(file: string) {
    return runFrom(baseLoaders, file);
}

export async function runLayoutDefault(file: string) {
    return runFrom(layoutLoaders, file);
}
